
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
@Component
export default class defaultclass extends  AbpBase{ 
  isTableLoading=false;
  get prox() {
    return new proxy.OperatorLogServiceProxy();
  }
  input: proxy.OperatorLogQueryInput = new proxy.OperatorLogQueryInput();
  dataList=[];
  columns = [
      {
        type: 'index',
        width: 60,
      align: 'center'
    },
    {
      title: '名称',
      key: 'operatorUserName'
    },
    {
      title: '操作内容',
      key: 'operatorContent'
    },
    {
        title:'操作时间',
        slot:'createTime'
    }
    ]
    getlist(operatorId:number,operatorTableName:number)
    {
       
        this.isTableLoading=true;
        this.input.operatorId=operatorId;
        this.input.operatorTableName=operatorTableName;
        this.prox.queryModelList(
            this.input
            ).then(x => {
            this.isTableLoading=false;
            this.dataList = x;
        });
    }
  
}
